import type { ModalProps } from '@mui/material';

import { Box, CircularProgress, IconButton, Modal, Typography } from '@mui/material';
import { Iconify } from '../iconify/iconify';


interface Props extends ModalProps {
  maxWidth?: number | string;
  minWidth?: number | string;
  maxHeight?: number;
  padding?: number;
  showCloseButton?: boolean;
  onClose?: () => void;
  title?: string;
  header?: React.ReactNode;
  loading?: boolean;
}

// Note: close button, header component and footer component may be needed
export const ResponsiveModal = ({
  children,
  maxWidth,
  minWidth,
  maxHeight,
  padding = 4,
  showCloseButton = true,
  onClose,
  title,
  header,
  loading,
  ...props
}: Props) => (
  <Modal {...props} container={document.body} open={props.open} onClose={() => !loading && onClose?.()}>
    <Box
      id="backdrop"
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%',
      }}
      onClick={() => !loading && onClose?.()}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'stretch',
          width: '100%',
          minWidth,
          maxWidth,
          maxHeight: maxHeight ?? 'calc(100vh - 48px)',
          bgcolor: 'background.paper',
          borderRadius: 2,
          p: padding,
          position: 'relative',
          overflow: 'hidden',
        }}
        onClick={(e) => e.stopPropagation()}
      >
        {loading && (
          <Box
            sx={{
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: '100%',
              height: '100%',
              zIndex: 1
            }}
          >
            <CircularProgress />
          </Box>
        )}
        {header ||
          ((title || showCloseButton) && (
            <Box
              sx={{
                width: '100%',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'flex-start',
                mb: 2,
                flexShrink: 0,
              }}
            >
              {title && <Typography variant="h6">{title}</Typography>}
              {showCloseButton && (
                <IconButton onClick={() => !loading && onClose?.()} color="default">
                  <Iconify icon="mdi:close" />
                </IconButton>
              )}
            </Box>
          ))}
        <Box
          sx={{
            flex: 1,
            minHeight: 0,
            overflowY: 'auto',
            width: '100%',
          }}
        >
          {children}
        </Box>
      </Box>
    </Box>
  </Modal>
);
